import React from 'react'
import PropTypes from 'prop-types'
import Chart from './Chart'
import Legend from './Legend'

import styles from './HorizontalStackedBarChart.module.scss'

const propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
      formattedValue: PropTypes.string,
      value: PropTypes.number,
    })
  ),
}

const noDataColor = styles.colorNoData

const colors = [
  styles.color1,
  styles.color2,
  styles.color3,
  styles.color4,
  styles.color5,
  styles.color6,
]

const dataWithColorInfo = (data) => {
  if (!data) return []

  return data.map((datapoint, index) => {
    const color = datapoint.value ? colors[index % colors.length] : noDataColor

    return Object.assign({ color }, datapoint)
  })
}

const ChartWithColorData = ({ data, ...restProps }) => (
  <Chart data={dataWithColorInfo(data)} {...restProps} />
)

const LegendWithColorData = ({ data, ...restProps }) => (
  <Legend data={dataWithColorInfo(data)} {...restProps} />
)

ChartWithColorData.propTypes = {
  ...propTypes,
  gapPercent: PropTypes.number,
}

LegendWithColorData.propTypes = propTypes

const HorizontalStackedBarChart = {}

HorizontalStackedBarChart.Chart = ChartWithColorData
HorizontalStackedBarChart.Legend = LegendWithColorData

export default HorizontalStackedBarChart
